import React, { useEffect, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import { TERMS_MODES } from '@/pages/workflow/renderers/_quoteTerms';

// Default Terms of Trade attached to every quote send / Save Quotation Pack / Update & Resend.
export const QuoteTermsDefault = () => {
  const { api } = useAuth();
  const [mode, setMode] = useState(null);

  useEffect(() => {
    api.get('/report-settings/quote-terms').then(({ data }) => setMode(data.mode)).catch(() => setMode('simple'));
  }, [api]);

  const save = async (next) => {
    const prev = mode;
    setMode(next);
    try {
      await api.put('/report-settings/quote-terms', { mode: next });
      toast.success('Default Terms of Trade for quotes saved');
    } catch (e) {
      setMode(prev);
      toast.error(e?.response?.data?.detail || 'Could not save');
    }
  };

  return (
    <div className="p-4 border border-orange-200 bg-orange-50/50 rounded-lg" data-testid="quote-terms-default">
      <div className="text-sm font-semibold text-slate-800">Terms of Trade sent with quotes</div>
      <div className="text-xs text-slate-600 mt-0.5 mb-3">
        Attached to the runner's Send Quote email, Save Quotation Pack and Update &amp; Resend. Simple goes one per quote (it shows that quote's total, deposit and warranty); Full goes once per job. You can still change it on each send.
      </div>
      <div className="flex gap-2">
        {TERMS_MODES.map((m) => (
          <button
            key={m.key}
            type="button"
            disabled={!mode}
            onClick={() => save(m.key)}
            data-testid={`quote-terms-default-${m.key}`}
            className={`px-4 py-1.5 rounded-md text-sm font-semibold border transition-colors ${mode === m.key ? 'bg-[#D35400] text-white border-[#D35400]' : 'bg-white text-slate-700 border-slate-300 hover:bg-slate-100'}`}
          >
            {m.label}
          </button>
        ))}
      </div>
      <OnlineAcceptanceAlert api={api} />
    </div>
  );
};

const OnlineAcceptanceAlert = ({ api }) => {
  const [on, setOn] = useState(null);
  useEffect(() => { api.get('/app-settings/online-acceptance').then(({ data }) => setOn(!!data.email_alert)).catch(() => setOn(false)); }, [api]);
  const toggle = async (v) => {
    setOn(v);
    try { await api.put('/app-settings/online-acceptance', { email_alert: v }); toast.success(v ? 'You will be emailed on online acceptances' : 'Online acceptances show in the CRM only'); }
    catch { setOn(!v); toast.error('Could not save'); }
  };
  if (on === null) return null;
  return (
    <label className="mt-4 pt-3 border-t border-orange-200 flex items-center gap-2 text-sm text-slate-700">
      <input type="checkbox" checked={on} onChange={(e) => toggle(e.target.checked)} data-testid="online-acceptance-email-alert" />
      Also email admins when a client pre-accepts a quote online (it always shows on the job and in the runner Follow-up)
    </label>
  );
};
